/* global axios */
import ApiClient from './ApiClient';

class PlanUsageAPI extends ApiClient {
  constructor() {
    super('plan_usage', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new PlanUsageAPI();
